var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,4h2v5h-2V4Zm8,11v2h5v-2h-5ZM0,17H5v-2H0v2ZM19.78,6.81l-3.54,3.54,1.41,1.41,3.54-3.54-1.41-1.41ZM2.81,8.22l3.54,3.54,1.41-1.41-3.54-3.54-1.41,1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreate);
export default __webpack_public_path__ + "static/1768397567/media/icon-create.89c142f8262bfa1d395d2859affb5a3b.svg";
export { ForwardRef as ReactComponent };